import React from 'react';
import { useMutation } from 'react-apollo-hooks';
import {
  changeSubjectMembershipPermissions,
  subjectMembersQuery
} from '../../../../queries/subjects';
import {
  ChangeSubjectMembershipPermissions,
  ChangeSubjectMembershipPermissionsVariables
} from '../../../../queries/__generated__/ChangeSubjectMembershipPermissions';
import { SubjectRoleType } from '../../../../__generated__/globalTypes';
import { Switch } from '../../../forms';

interface AdminSwitch {
  subject: {
    id: string;
  };
  subjectMember: {
    id: string;
    roleType: string;
  };
  disabled?: boolean;
}

const AdminSwitch: React.FC<AdminSwitch> = ({ subjectMember, subject, disabled }) => {
  const toggleAdminRights = useMutation<
    ChangeSubjectMembershipPermissions,
    ChangeSubjectMembershipPermissionsVariables
  >(changeSubjectMembershipPermissions, {
    variables: {
      input: {
        subjectMembershipId: subjectMember.id,
        roleType:
          subjectMember.roleType === SubjectRoleType.ADMIN ? SubjectRoleType.MEMBER : SubjectRoleType.ADMIN
      }
    },
    refetchQueries: [
      {
        query: subjectMembersQuery,
        variables: { input: { subjectId: subject.id } }
      }
    ]
  });

  return (
    <Switch
      active={subjectMember.roleType.toUpperCase() === 'ADMIN'}
      onClick={toggleAdminRights}
      disabled={disabled}
    />
  );
};

export default AdminSwitch;
